<template>
  <div class="home">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
        <v-row class="fill-height" align="center" justify="center">
          <div class="text-h1 white--text">
            {{ item.title }}
          </div>
        </v-row></v-carousel-item
      >
    </v-carousel>
    <!-- <div class="container">
      <backtospeisekarte></backtospeisekarte>
    </div> -->
    <v-card>
      <v-card-title class="display-3">
        Salate
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
// import Backtospeisekarte from './Backtospeisekarte.vue';
export default {
  // components: { Backtospeisekarte },
  name: 'Salate',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/ingwersalat-cutted.png'),
          title: '',
        },
        {
          src: require('../assets/images/tofusalat-uncutted-background.jpg'),
          title: '',
        },
        {
          src: require('../assets/images/pikantesalat-uncutted-background.jpg'),
          title: '',
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        // {
        //   nummer: '21',
        //   speise: 'Meeresfrüchte Salat',
        //   allergene: '(B, D)',
        //   preis: '5,60 €',
        // },
        // {
        //   nummer: '22',
        //   speise: 'Garnelen Salat',
        //   allergene: '(N, R)',
        //   preis: '5,70 €',
        // },
        {
          nummer: '23',
          speise: 'Tofu Salat',
          allergene: '(F, N)',
          preis: '5,20 €',
        },
        {
          nummer: '24',
          speise: 'Kimchi',
          allergene: '(A, F, N)',
          preis: '6,50 €',
        },
        {
          nummer: '25',
          speise: 'Gurkensalat',
          allergene: '(A, F, N)',
          preis: '5,50 €',
        },
        {
          nummer: '26',
          speise: 'Gemischter Salat',
          allergene: '(F, N)',
          preis: '6,70 €',
        },
        {
          nummer: '27',
          speise: 'Edamame',
          allergene: '(A, F)',
          preis: '6,50 €',
        },
        {
          nummer: '28',
          speise: 'Ingwer Salat',
          allergene: '/',
          preis: '4,70 €',
        },
        {
          nummer: '29',
          speise: 'Pikant-Krautsalat',
          allergene: '(N, R)',
          preis: '5,20 €',
        },
        // {
        //   nummer: '30',
        //   speise: 'Seetangsalat',
        //   allergene: '(A, F, N, R)',
        //   preis: '5,20 €',
        // },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
